import React from "react";
import ChessRules from "../components/ChessRules";

const Rules = () => {
  return (
    <main>
      <ChessRules />
    </main>
  );
};

export default Rules;
